export const GET_QUOTES_LIST = "GET_QUOTES_LIST";